<template>
  <b-container>
    <b-row>
      <b-col
        cols="12"
        sm="6"
        class="name lightgrey"
        @mouseover="name_editable = true"
        @mouseout="name_editable = false"
      >
        <label :class="label_classes(show_name_infos)">
          <b> {{ $t('brick_name') }} </b>
        </label>

        <b-form-input v-if="editing_name" v-model="name" />
        <div
          v-else
          :class="edit_classes(show_name_infos)"
          class="d-flex flex-column flex-sm-row justify-content-between align-items-center"
          style="word-break: break-all;"
        >
          <h4 class="inline">
            {{ name }}
          </h4>

          <b-button
            size="sm"
            variant="outline-secondary"
            :class="button_classes(show_name_infos)"
            class="m-2"
            @click="editing_name = true"
          >
            <span class="fas fa-pen fa-xs" />
          </b-button>
        </div>
      </b-col>

      <b-col
        cols="12"
        sm="6"
        class="description lightgrey"
        @mouseover="description_editable = true"
        @mouseout="description_editable = false"
      >
        <label :class="label_classes(show_description_infos)">
          <b> {{ $t('brick_description') }} </b>
        </label>

        <b-form-textarea v-if="editing_description" v-model="description" />
        <div
          v-else
          :class="edit_classes(show_description_infos)"
          class="d-flex flex-column flex-sm-row justify-content-between align-items-center"
          style="word-break: break-all;"
        >
          <span> {{ description }} </span>
          <b-button
            size="sm"
            variant="outline-secondary"
            :class="button_classes(show_description_infos)"
            class="m-2"
            @click="editing_description = true"
          >
            <span class="fas fa-pen fa-xs" />
          </b-button>
        </div>
      </b-col>
    </b-row>
  </b-container>
</template>

<i18n>
{
  "en": {
    "brick_name": "Brick name",
    "brick_description": "Brick description"
  },
  "fr": {
    "brick_name": "Nom de la brique",
    "brick_description": "Description de la brique"
  }
}
</i18n>

<style lang="scss" scoped>
@import './../custom-bootstrap.scss';

.inline {
  display: inline;
}

.edit {
  border: 1px solid transparent;
  padding: 5px 3px 5px 13px;
  border-radius: 3px;
  min-height: 42px;
}

.grey-border {
  border-color: $gray-400;
}
</style>

<script>
import _ from 'lodash'

// *****************************************************************************

export default {
  name: 'DescriptionEdition',
  props: ['value'],
  data() {
    return {
      editing_name: false,
      editing_description: false,
      name_editable: false,
      description_editable: false,
      name: '',
      description: '',
    }
  },

  computed: {
    local_value() {
      const name = this.name
      const description = this.description
      return { name, description }
    },

    show_name_infos() {
      return this.name_editable || this.editing_name
    },

    show_description_infos() {
      return this.description_editable || this.editing_description
    },
  },

  watch: {
    value: {
      immediate: true,
      handler(nv) {
        nv = nv || {}
        if (!_.isEqual(nv, this.local_value)) {
          this.name = nv.name || ''
          this.description = nv.description || ''
        }
      },
    },
    local_value(nv, ov) {
      if (!_.isEqual(nv, ov)) {
        this.$emit('input', nv)
      }
    },
  },

  methods: {
    label_classes(show) {
      let res = []
      if (!show) {
        res.push('invisible')
      }
      return res
    },

    button_classes(show) {
      let res = ['button', 'float-right']
      if (!show) {
        res.push('invisible')
      }
      return res
    },

    edit_classes(show) {
      let res = ['edit']
      if (show) {
        res.push('grey-border')
      }
      return res
    },

    saved() {
      this.editing_name = false
      this.editing_description = false
    },
  },
}
</script>
